export const NOTIFICATION_TYPES = {
  EMAIL: 'EMAIL',
  WEBHOOK: 'WEBHOOK',
};
